
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import Empty from "@/components/empty.vue";
import Transfer from "../components/transfer.vue";
import {
  GetGroupData,
  GetGroupTemList,
  PostAddGroup,
  PatchEditGroup,
  DelGroup,
  PostSortGroupTem,
  DelGroupTem,
  PatchGroupTem,
  GetTemData,
  GetPlanData,
} from "@/request/common";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Empty,
    Transfer,
  },
})
export default class Name extends Vue {
  private list: any = [];
  private data: any = {};
  private cSelect: any = {};
  private ifShowEditZuhe: any = false;
  private editGroupData: any = {};
  private searchText: any = "";
  private plans: any = [];
  private allTemData: any = [];
  private curData: any = [];
  private IfShowTransfer: any = false;
  private defaultProps: any = {
    children: "children",
    label: "name",
  };
  private getPlans() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPlanData(this, {}, loading).then((res: any) => {
      this.plans = res.data;
    });
  }
  private goPreview(item: any) {
    this.$router.push({
      path: "/main/manage/group-preview",
      query: {
        group_id: this.cSelect.id,
        tem_id: item.template.id,
      },
    });
  }
  private transferChange(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    let arr: any = [];
    e.forEach((ele: any) => {
      arr.push({ id: ele.id });
    });
    const params: any = {
      template: arr,
    };
    PatchEditGroup(this, this.cSelect.id, params, loading).then((res: any) => {
      this.$message.success("保存成功");
      this.IfShowTransfer = false;
      this.getData();
    });
  }
  private openTransfer() {
    const params: any = {};
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemData(this, params, loading).then((res: any) => {
      this.allTemData = res.data;
      this.curData = [];
      this.data.template.forEach((ele: any) => {
        this.curData.push(ele.template);
      });
      this.IfShowTransfer = true;
    });
  }
  private changeRequire(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      required: !item.required,
    };
    PatchGroupTem(this, item.id, params, loading).then((res: any) => {
      this.$message.success("设置成功");
      this.getData();
    });
  }
  private delTem(item: any) {
    this.$confirm("您是否确定删除当前量表吗？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelGroupTem(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getData();
      });
    });
  }
  private handleDrop() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      group_templates: this.data.template,
    };
    PostSortGroupTem(this, params, loading).then((res: any) => {
      this.getData();
    });
  }
  private selectOne(items: any) {
    this.cSelect = items;
    this.getData();
  }
  private delOne(item: any) {
    this.$confirm("您是否确定删除当前组合？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelGroup(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        // 如果删除的是当前的需要处理数据
        if (this.cSelect.id == item.id) {
          this.data = {};
          this.cSelect = {};
          this.getList();
        } else {
          this.getList();
        }
      });
    });
  }
  private openEditZuhe(item: any) {
    if (item) {
      this.editGroupData = JSON.parse(JSON.stringify(item));
    } else {
      this.editGroupData = {};
    }
    this.getPlans();
    this.ifShowEditZuhe = true;
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        search: this.searchText,
        ordering: "-update_datetime",
      },
    };
    GetGroupData(this, params, loading).then((res: any) => {
      this.list = res.data;
      if (!this.cSelect.id && this.list.length > 0) {
        this.cSelect = this.list[0];
        this.getData();
      } else {
        // 需要更新当前选中信息
        this.list.forEach((ele: any) => {
          if (ele.id == this.cSelect.id) {
            this.cSelect = ele;
          }
        });
      }
    });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        group: this.cSelect.id,
      },
    };
    GetGroupTemList(this, params, loading).then((res: any) => {
      this.data = {
        template: res.data,
      };
    });
  }
  private saveGroup() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.editGroupData.id) {
      PatchEditGroup(
        this,
        this.editGroupData.id,
        this.editGroupData,
        loading
      ).then((res: any) => {
        this.$message.success("保存成功");
        this.getList();
        this.ifShowEditZuhe = false;
        // 如果编辑的是当前选中的需要刷新数据
        if (this.editGroupData.id == this.cSelect.id) {
          this.getData();
        }
      });
    } else {
      PostAddGroup(this, this.editGroupData, loading).then((res: any) => {
        this.$message.success("保存成功");
        this.getList();
        this.ifShowEditZuhe = false;
      });
    }
  }
  private mounted() {
    this.getList();
  }
}
